// src/v2/pages/Reports/ReportML1.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportML1 } from '../../hooks/useReportML1';
import { ReportML1Module } from '../../components/modules/Reports/ReportML1/ReportML1Module';

const ReportML1 = ({ isHideSideMenu }) => {
  const reportHook = useReportML1();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportML1Module reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportML1;